import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Report\ConvertReportToDashboardController::__invoke
* @see app/Http/Controllers/Report/ConvertReportToDashboardController.php
* @route '/api/reports/{report}/dashboard'
*/
const ConvertReportToDashboardController = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ConvertReportToDashboardController.url(args, options),
    method: 'post',
})

ConvertReportToDashboardController.definition = {
    methods: ["post"],
    url: '/api/reports/{report}/dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Report\ConvertReportToDashboardController::__invoke
* @see app/Http/Controllers/Report/ConvertReportToDashboardController.php
* @route '/api/reports/{report}/dashboard'
*/
ConvertReportToDashboardController.url = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return ConvertReportToDashboardController.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Report\ConvertReportToDashboardController::__invoke
* @see app/Http/Controllers/Report/ConvertReportToDashboardController.php
* @route '/api/reports/{report}/dashboard'
*/
ConvertReportToDashboardController.post = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ConvertReportToDashboardController.url(args, options),
    method: 'post',
})

export default ConvertReportToDashboardController